export enum SignUp {
  CREATE_SIGN_UP_USER_REQUEST = '@signup/CREATE_SIGN_UP_USER_REQUEST',
  CREATE_SIGN_UP_USER_SUCCESS = '@signup/CREATE_SIGN_UP_USER_SUCCESS',
  CREATE_SIGN_UP_USER_FAIL = '@signup/CREATE_SIGN_UP_USER_FAIL',

  CREATE_SIGN_UP_USER_IDENTITY_REQUEST = '@signup/CREATE_SIGN_UP_USER_IDENTITY_REQUEST',
  CREATE_SIGN_UP_USER_IDENTITY_SUCCESS = '@signup/CREATE_SIGN_UP_USER_IDENTITY_SUCCESS',
  CREATE_SIGN_UP_USER_IDENTITY_FAIL = '@signup/CREATE_SIGN_UP_USER_IDENTITY_FAIL',

  VERIFY_SIGN_UP_USER_IDENTITY_REQUEST = '@signup/VERIFY_SIGN_UP_USER_IDENTITY_REQUEST',
  VERIFY_SIGN_UP_USER_IDENTITY_SUCCESS = '@signup/VERIFY_SIGN_UP_USER_IDENTITY_SUCCESS',
  VERIFY_SIGN_UP_USER_IDENTITY_FAIL = '@signup/VERIFY_SIGN_UP_USER_IDENTITY_FAIL',

  UPDATE_SIGN_UP_USER_REQUEST = '@signup/UPDATE_SIGN_UP_USER_REQUEST',
  UPDATE_SIGN_UP_USER_SUCCESS = '@signup/UPDATE_SIGN_UP_USER_SUCCESS',
  UPDATE_SIGN_UP_USER_FAIL = '@signup/UPDATE_SIGN_UP_USER_FAIL',

  COMPLETE_SIGN_UP_REQUEST = '@signup/COMPLETE_SIGN_UP_REQUEST',
  COMPLETE_SIGN_UP_SUCCESS = '@signup/COMPLETE_SIGN_UP_SUCCESS',
  COMPLETE_SIGN_UP_FAIL = '@signup/COMPLETE_SIGN_UP_FAIL',

  RESEND_IDENTITY_VERIFICATION_CODE_REQUEST = '@signup/RESEND_IDENTITY_VERIFICATION_CODE_REQUEST',
  RESEND_IDENTITY_VERIFICATION_CODE_SUCCESS = '@signup/RESEND_IDENTITY_VERIFICATION_CODE_SUCCESS',
  RESEND_IDENTITY_VERIFICATION_CODE_FAIL = '@signup/RESEND_IDENTITY_VERIFICATION_CODE_FAIL',

  CLEAR_SIGN_UP_USER = '@signup/CLEAR_SIGN_UP_USER',
}
